<template>
  <v-dialog
    v-model="menu_ativo"
    persistent
    max-width="800"
    content-class="bra-10"
    transition="dialog-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <slot
        v-if="$scopedSlots.activator"
        name="activator"
        :on="on"
        :attrs="attrs"
      />

      <SysBtn
        v-else
        :class="contentClass"
        :size="size"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon size="18">mdi-filter</v-icon>
        <span class="ml-1">{{ texto_botao_ativador }}</span>
      </SysBtn>
    </template>

    <v-card class="pb-2 pa-2 border-gray-500 overflow-y-auto" elevation="10" style="max-height: 80vh">
      <v-card-title class="position-sticky pl-4 pr-1 py-2">
        <div class="filtro-div-fixa">
          <p class="ma-0 font-18 text-gray-900">Filtragem de produtos</p>
          <p class="ma-0 font-12 font-weight-regular mt-n3 text-gray-200">
            Selecione o que deseja considerar
          </p>
        </div>

        <v-spacer />

        <v-btn icon @click="menu_ativo = !menu_ativo">
          <v-icon size="22">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-card-text class="px-2">
        <slot name="prepend" />

        <template v-if="!ocultar_filtros_fixos">
          <v-checkbox v-model="filtros.fora_de_linha" hide-details class="mt-3 pb-3">
            <template #label>
              <span class="ml-1 font-15">Produtos fora de linha</span>
            </template>
          </v-checkbox>

          <v-checkbox v-model="filtros.inativo_revenda" hide-details class="pb-3">
            <template #label>
              <span class="ml-1 font-15">Produtos inativos para revenda</span>
            </template>
          </v-checkbox>

          <v-checkbox v-model="filtros.produto_resgatado" hide-details class="pb-3">
            <template #label>
              <div>
                <p class="ma-0 ml-1 font-15">Produtos resgatados</p>
                <p class="ma-0 ml-1 mt-n1 font-12 text-gray-200">
                  Última entrada menor ou igual a 90 dias e estoque zerado por 30 dias antes da última entrada.
                </p>
              </div>
            </template>
          </v-checkbox>

          <v-checkbox v-model="filtros.venda_futura_maior_que_saldo_estoque" hide-details class="pb-4">
            <template #label>
              <Legenda
                titulo="Ocultar itens com Venda Futura maior que o Estoque"
                legenda="Este filtro remove da análise os itens cujo estoque está totalmente comprometido com pedidos já fechados, aguardando apenas a entrega ao cliente. Produtos com estoque maior que os pedidos fechados aparecem normalmente."
              >
                <div>
                  <p class="ma-0 ml-1 font-15">Ocultar itens com Venda Futura maior que o Estoque</p>

                  <p class="ma-0 ml-1 mt-n1 font-12 text-gray-200">
                    Produtos que já foram vendidos e estão aguardando liberação.
                  </p>
                </div>
              </Legenda>
            </template>
          </v-checkbox>
        </template>

        <div class="ml-2 mr-1 mt-4">
          <div class="d-flex align-center">
            <div class="w-33-porcento pr-1">
              <v-autocomplete
                v-model="filtros.primeira_entrada"
                label="Primeira entrada"
                :items="selects.intervalo_dias"
                item-text="descricao"
                item-value="valor"
                outlined
                multiple
                clearable
                hide-details
                small-chips
                :height="ALTURA_MINIMA_FILTROS_DIAS"
              />
            </div>

            <div class="w-33-porcento px-1">
              <v-autocomplete
                v-model="filtros.ultima_entrada"
                label="Última entrada"
                :items="selects.intervalo_dias"
                item-text="descricao"
                item-value="valor"
                outlined
                multiple
                clearable
                hide-details
                small-chips
                :height="ALTURA_MINIMA_FILTROS_DIAS"
              />
            </div>

            <div class="w-33-porcento pl-1">
              <v-autocomplete
                v-model="filtros.idade"
                label="Idade dos produtos"
                :items="selects.intervalo_dias"
                item-text="descricao"
                item-value="valor"
                outlined
                multiple
                clearable
                hide-details
                small-chips
                :height="ALTURA_MINIMA_FILTROS_DIAS"
              />
            </div>
          </div>

          <slot name="append">
            <template v-if="!ocultar_filtro_combinados">
              <DivisorComLegenda legenda="Filtros de produtos combinados" class="my-5" />
              <TiposProdutoAutocomplete v-model="filtros.tipos_produtos" />
            </template>

            <DivisorComLegenda legenda="Outros" class="my-5" />

            <div class="d-flex align-center">
              <div class="w-33-porcento pr-2">
                <SysCompradorAutocomplete
                  v-model="filtros.compradores"
                  label="Compradores"
                  :qtde_visivel_selecionados="1"
                  :ids-grupo="filtros.grupos"
                  :ids-filial="filtros.filiais"
                  :ids-segmento="filtros.segmentos"
                  :ids-secao="filtros.secoes"
                  outlined
                  multiple
                  hide-details
                  clearable
                />
              </div>

              <div class="w-33-porcento pr-2">
                <SysFornecedorAutocomplete
                  v-model="filtros.fornecedores"
                  label="Fornecedores"
                  :qtde-visivel-selecionados="1"
                  :ids-grupo="filtros.grupos"
                  :ids-filial="filtros.filiais"
                  :ids-segmento="filtros.segmentos"
                  :ids-secao="filtros.secoes"
                  :ids-comprador="filtros.compradores"
                  outlined
                  multiple
                  hide-details
                  clearable
                />
              </div>

              <div class="w-33-porcento">
                <SysLinhasAutocomplete
                  v-model="filtros.linhas"
                  label="Linhas"
                  :qtde_visivel_selecionados="1"
                  :ids-grupo="filtros.grupos"
                  :ids-filial="filtros.filiais"
                  :ids-segmento="filtros.segmentos"
                  outlined
                  multiple
                  hide-details
                  clearable
                  :autoselecionar_linhas_com_movimento="autoselecionar_linhas_com_movimento"
                  @autoselecionado-linhas-com-movimento="aplicarFiltros"
                />
              </div>
            </div>

            <div class="d-flex align-center mt-3">
              <div class="w-33-porcento pr-2">
                <SysSegmentoAutocomplete
                  v-model="filtros.segmentos"
                  label="Segmentos"
                  :qtde-visivel-selecionados="1"
                  outlined
                  multiple
                  hide-details
                  clearable
                />
              </div>

              <div class="w-33-porcento pr-2">
                <SysSecaoAutocomplete
                  v-model="filtros.secoes"
                  :qtde_visivel_selecionados="1"
                  :ids-grupo="filtros.grupos"
                  :ids-filial="filtros.filiais"
                  :ids-segmento="filtros.segmentos"
                  label="Seções"
                  outlined
                  multiple
                  hide-details
                  clearable
                />
              </div>

              <div class="w-33-porcento">
                <SysCategoriaAutocomplete
                  v-model="filtros.categorias"
                  :qtde_visivel_selecionados="1"
                  :ids-grupo="filtros.grupos"
                  :ids-filial="filtros.filiais"
                  :ids-segmento="filtros.segmentos"
                  :ids-secao="filtros.secoes"
                  label="Categorias"
                  outlined
                  multiple
                  hide-details
                  clearable
                />
              </div>
            </div>

            <div class="d-flex align-center mt-3">
              <div class="w-33-porcento pr-2">
                <SysMarcaAutocomplete
                  v-model="filtros.marcas"
                  :qtde-visivel-selecionados="1"
                  :ids-grupo="filtros.grupos"
                  :ids-filial="filtros.filiais"
                  :ids-segmento="filtros.segmentos"
                  :ids-secao="filtros.secoes"
                  :ids-comprador="filtros.compradores"
                  label="Marcas"
                  outlined
                  multiple
                  hide-details
                  clearable
                />
              </div>

              <div class="w-33-porcento pr-2">
                <SysProdutosAutocomplete
                  v-model="filtros.produtos"
                  :ids_produtos_permitidos="ids_produtos_permitidos"
                  :qtde_visivel_selecionados="1"
                  label="Produtos"
                  outlined
                  multiple
                  hide-details
                  clearable
                  desabilitar_botao_selecao_todos
                />
              </div>

              <div class="w-33-porcento">
                <SysStatusProduto v-model="filtros.status_produto" />
              </div>
            </div>

            <div class="d-flex align-center mt-3">
              <div class="w-33-porcento pr-2">
                <SysAutocomplete
                  v-model="filtros.status_estoque"
                  :items_props="selects.status_estoque"
                  label_props="Status de estoque"
                  outlined
                  multiple
                  :qtde-visivel-selecionados="1"
                  clearable
                  hide-details
                />
              </div>

              <div class="w-33-porcento pr-2">
                <SysHistograma v-model="filtros.histogramas" />
              </div>

              <div class="w-33-porcento">
                <SysAutocomplete
                  v-model="filtros.pedidos_pendentes"
                  label_props="Pedidos Pendentes"
                  :items_props="selects.items_props_produtos_pendentes"
                />
              </div>

              <slot name="pedidos_pendentes.append"></slot>
            </div>

            <div class="d-flex align-center mt-3">
              <div class="w-33-porcento pr-2">
                <SysAutocomplete
                  v-model="filtros.curva_faturamento"
                  :items_props="selects.curva_faturamento"
                  label_props="Curva Faturamento"
                  outlined
                  multiple
                  :qtde-visivel-selecionados="1"
                  clearable
                  hide-details
                />
              </div>

              <div class="w-33-porcento pr-2">
                <SysAutocomplete
                  v-model="filtros.curva_popularidade"
                  :items_props="selects.curva_popularidade"
                  label_props="Curva Popularidade"
                  outlined
                  multiple
                  :qtde-visivel-selecionados="1"
                  clearable
                  hide-details
                />
              </div>

              <div class="w-33-porcento">
                <SysAutocomplete
                  v-model="filtros.curva_rentabilidade"
                  :items_props="selects.curva_rentabilidade"
                  label_props="Curva Rentabilidade"
                  outlined
                  multiple
                  :qtde-visivel-selecionados="1"
                  clearable
                  hide-details
                />
              </div>
            </div>

            <slot name="append.outros_filtros"></slot>
          </slot>
        </div>
      </v-card-text>

      <div class="d-flex px-2 mt-3">
        <v-spacer />

        <v-btn small class="mr-2" color="#ffffff" @click="limparFiltros">
          limpar filtros
        </v-btn>

        <v-btn small class="mr-2" color="#757575" dark @click="cancelar">
          cancelar
        </v-btn>

        <v-btn small color="#042333" dark @click="aplicarFiltros">
          filtrar
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import DivisorComLegenda from "@/components/utils/DivisorComLegenda.vue";
import SysCategoriaAutocomplete from "@/components/utils/crud/SysCategoriaAutocomplete.vue";
import TiposProdutoAutocomplete from "@/components/indicadores/SysTiposProdutoAutocomplete.vue";
import SysLinhasAutocomplete from "@/components/utils/crud/SysLinhasAutocomplete.vue";
import SysStatusProduto from "@/components/utils/crud/SysStatusProduto.vue";
import SysSecaoAutocomplete from "@/components/utils/crud/SysSecaoAutocomplete.vue";
import TextoOutrosFiltrosSelecionadosAutocomplete
  from "@/components/Diagnostico/utils/TextoOutrosFiltrosSelecionadosAutocomplete.vue";
import SysSegmentoAutocomplete from "@/components/utils/crud/SysSegmentoAutocomplete.vue";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete.vue";
import SysCompradorAutocomplete from "@/components/utils/crud/SysCompradorAutocomplete.vue";
import SysAutocomplete from "@/components/utils/crud/SysAutocomplete.vue";
import SysHistograma from "@/components/Eventos/SazonalidadeFinal/Filtros/SysHistograma.vue";
import SysProdutosAutocomplete from "@/components/utils/crud/SysProdutosAutocomplete.vue";
import Legenda from "@/components/produto/detalhes/Legenda.vue";
import SysMarcaAutocomplete from "@/components/utils/crud/SysMarcaAutocomplete.vue";
import FiltrosAutocomplete from "@/components/compra/ProdutosGerais/Filtros/FiltrosAutocomplete.vue";

export default {
  name: "FiltrosUniversalAvancado",
  components: {
    FiltrosAutocomplete,
    Legenda,
    SysProdutosAutocomplete,
    SysHistograma,
    SysAutocomplete,
    SysCompradorAutocomplete,
    SysFornecedorAutocomplete,
    SysSegmentoAutocomplete,
    TextoOutrosFiltrosSelecionadosAutocomplete,
    SysSecaoAutocomplete,
    SysStatusProduto,
    SysLinhasAutocomplete,
    TiposProdutoAutocomplete,
    SysCategoriaAutocomplete,
    SysMarcaAutocomplete,
    DivisorComLegenda
  },
  props: {
    texto_botao_ativador: {
      type: String,
      default: "Filtros"
    },
    contentClass: {
      type: String,
      default: ''
    },
    size: Number,
    ocultar_filtros_fixos: {
      type: Boolean,
      default: false
    },
    ocultar_filtro_combinados: {
      type: Boolean,
      default: false
    },
    eager: Boolean,
    autoselecionar_linhas_com_movimento: Boolean,
    ids_produtos_permitidos: {
      type: Array,
      default: () => ([]),
      required: false
    },
  },
  data: () => ({
    menu_ativo: false,
    filtros: {},
    selects: {
      intervalo_dias: [
        { valor: 1, descricao: '1. Menor que 90 dias' },
        { valor: 2, descricao: '2. Entre 90 e 180 dias' },
        { valor: 3, descricao: '3. Maior que 180 dias' },
        { valor: 4, descricao: '4. Sem entrada' },
      ],
      status_estoque: [
        { id: 'NAO', descricao: '1. Ativo' },
        { id: 'SIM', descricao: '2. Fora de Linha' }
      ],
      items_props_produtos_pendentes: [
        { id: 1, descricao: '1. Produtos sem Pedido Pendente' },
        { id: 2, descricao: '2. Produtos com Pedido Pendente' },
      ],
      curva_popularidade: [
        { id: 'P', descricao: '1. Frequência Alta de Saída' },
        { id: 'Q', descricao: '2. Frequência Média de Saída' },
        { id: 'R', descricao: '3. Frequência Baixa de Saída' },
        { id: 'S', descricao: '4. Frequência Muito Baixa de Saída' }
      ],
      curva_faturamento: [
        { id: 'Z', descricao: '1. Faturamento Elevado' },
        { id: 'Y', descricao: '2. Faturamento Médio' },
        { id: 'X', descricao: '3. Faturamento Baixo' }
      ],
      curva_rentabilidade: [
        { id: 'A', descricao: '1. Rentabilidade Elevada' },
        { id: 'B', descricao: '2. Rentabilidade Média' },
        { id: 'C', descricao: '3. Rentabilidade Baixa' }
      ],
    }
  }),
  computed: {
    FILTROS_COMPUTED: {
      get: function () {
        return this.$store.getters['filtrosUniversalAvancado/filtros'];
      },
      set: function (valor) {
        this.$store.dispatch('filtrosUniversalAvancado/filtros', valor);
      }
    },
    ALTURA_MINIMA_FILTROS_DIAS() {
      const { primeira_entrada, ultima_entrada, idade } = this.filtros;
      return Math.max(primeira_entrada.length, ultima_entrada.length, idade.length, 1) * 37;
    },
  },
  created() {
    this.filtros = { ...this.FILTROS_COMPUTED };
  },
  watch: {
    FILTROS_COMPUTED: {
      handler() {
        this.filtros = { ...this.FILTROS_COMPUTED };
      },
      deep: true
    },
    'filtros.primeira_entrada'(val) {
      const sorteado = [...val].map(Number).sort((a, b) => a - b)

      if (sorteado.some((n, i) => n !== val[i])) {
        this.filtros.primeira_entrada = sorteado
      }
    },
    'filtros.ultima_entrada'(val) {
      const sorteado = [...val].map(Number).sort((a, b) => a - b)

      if (sorteado.some((n, i) => n !== val[i])) {
        this.filtros.ultima_entrada = sorteado
      }
    },
    'filtros.idade'(val) {
      const sorteado = [...val].map(Number).sort((a, b) => a - b)

      if (sorteado.some((n, i) => n !== val[i])) {
        this.filtros.idade = sorteado
      }
    }
  },
  methods: {
    aplicarFiltros() {
      this.FILTROS_COMPUTED = { ...this.filtros };
      this.menu_ativo = false;

      this.$emit("update:filtros", { filtros: this.filtros });
    },
    cancelar() {
      this.menu_ativo = false;
    },
    limparFiltros() {
      this.$store.dispatch('filtrosUniversalAvancado/limpar_filtros')
      this.$emit("limpar:filtros", {});
    }
  }
}
</script>
